<template>
<div>
    <v-layout row wrap align-baseline mb-5>
        <v-flex xs12 md8>
            <h4 class="title">
                <v-icon>face</v-icon>
                {{student.first_name}} {{student.last_name}} - Grade {{student.grade}}
            </h4>
        </v-flex>
        <v-flex xs12 md4>
            <v-select :items="semesters" item-text="name" label="Choose a semester to see classes" return-object v-model="chosenSemester">
            </v-select>
        </v-flex>
        <v-flex xs12 md12>
            <v-btn class="primary" small :disabled="chosenSemester.name === undefined" @click="print()">
                <v-icon>print</v-icon>
                Download Schedule
            </v-btn>
        </v-flex>
    </v-layout>
    <v-data-table :headers="headers" :items="schedule" hide-actions style="margin-bottom: 2rem;">
        <template slot="items" slot-scope="props">
            <tr>
                <td>{{ props.item.section }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.teacher.last_name }}</td>
                <td>{{ props.item.days }}</td>
                <td>{{ props.item.time }}</td>
                <td>{{ props.item.period }}</td>
                <td>{{ props.item.semester }}</td>
            </tr>
        </template>
    </v-data-table>
</div>
</template>

<script>
import {
    printSchedule
} from '@/helpers/printStudentSchedule.js'

export default {
    props: {
        active: {
            type: Boolean,
            required: true
        },
        student: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chosenSemester: {},
            headers: [{
                    text: 'Section',
                    sortable: false,
                    align: 'left',
                    value: 'section',
                    width: '10%'
                },
                {
                    text: 'Name',
                    sortable: false,
                    align: 'left',
                    value: 'name',
                    width: '25%'
                },
                {
                    text: 'Teacher',
                    sortable: false,
                    align: 'left',
                    value: 'teacher.last_name',
                    width: '25%'
                },
                {
                    text: 'Days',
                    sortable: false,
                    align: 'left',
                    value: 'days',
                    width: '10%'
                },
                {
                    text: 'Time',
                    sortable: false,
                    align: 'left',
                    value: 'time',
                    width: '10%'
                },
                {
                    text: 'Period',
                    sortable: false,
                    align: 'left',
                    value: 'period',
                    width: '10%'
                },
                {
                    text: 'Semester',
                    sortable: false,
                    align: 'left',
                    value: 'semester',
                    width: '10%'
                }
            ]
        }
    },
    computed: {
        schedule() {
            return this.$store.state.enrollment.schedule.enrolled
        },
        semesters() {
            return this.$store.getters.activeSemesters
        }
    },
    watch: {
        'active'(value) {
            if (value) {
                this.$store.commit('setEnrollmentStudent', this.student)
            } else {
                this.chosenSemester = ''
                this.$store.commit('clearEnrollmentSchedule')
            }
        },
        'chosenSemester'(semester) {
            this.$store.dispatch('getStudentSchedule', semester.name)
        }
    },
    methods: {
        print() {
            printSchedule(this.student, this.$store.getters.formattedStudentSchedule, this.chosenSemester)
        }
    }
}
</script>
